import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import { CanonicalManager } from './components/seo/CanonicalManager'
import { ScrollToTop } from './components/base/ScrollToTop'
import ErrorBoundary from './components/base/ErrorBoundary'


function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <CanonicalManager />
      <ScrollToTop />
      <ErrorBoundary>
        <AppRoutes />
      </ErrorBoundary>
    </BrowserRouter>
  )
}

export default App
